import React, { useEffect, useState } from "react";
import bgImage from 'assets/images/school.jpg';
import { EventCard } from "components/EventCard/eventCard";
import { Post } from "components/Post/post";
import { useNavigate } from "react-router-dom";
import UserApi from "apis/UserApi";
import { FeedsModal } from "components/FeedsModal/feedsModal";

function MainComponent() {
  const navigate = useNavigate()
  const [user, setUser] = useState();
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);
  const [showFeedsModal, setShowFeedsModal] = useState(false);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [feeds, setFeeds] = useState([]);
  const [news, setNews] = useState([]);
  const [description, setDescription] = useState('');
  const [showDescription, setShowDescription] = useState(false);
  const [achievements, setAchievements] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const base_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    const checkAuth = () => {
      const localToken = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      if (localToken && user) {
        setUser(JSON.parse(user));
      }
      setIsAuthenticated(!!localToken);
    };

    checkAuth();
    // Add event listener for storage changes
    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        let achievements = [];
        let news = [];
        let feeds = [];
        const [eventsResponse, feedsResponse] = await Promise.all([
          UserApi.getAllEvents(),
          UserApi.getAllFeeds()
        ]);
        setEvents(eventsResponse?.data?.data || []);
        feedsResponse?.data?.data?.forEach(feed => {
          switch(feed.feed_type){
            case 'achievement':
             achievements.push(feed);
             setAchievements(achievements);
              break;
            case 'information':
              news.push(feed);
              setNews(news);
              break;
            case 'meetup':
              feeds.push(feed);
              setFeeds(feeds);
              break;
            default:
              break;
          }

        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, []);


  // First, update the news array data structure to include images
  // const news = [
  //   {
  //     title: "New Alumni Chapter Launched",
  //     date: "February 1, 2025",
  //     description: "Opening of our new international chapter in Singapore",
  //     image: bgImage,
  //   },
  //   {
  //     title: "Scholarship Fund Achievement",
  //     date: "January 15, 2025",
  //     description: "Alumni contributions help establish new merit scholarships",
  //     image: bgImage,
  //   },
  // ];
  // const achievements = [
  //   {
  //     name: "Dr. Sarah Khan",
  //     year: "2010",
  //     description: "Leading groundbreaking research in quantum computing at MIT, Dr. Khan's work has been published in Nature and Science. Recently awarded the Presidential Early Career Award for Scientists and Engineers (PECASE).",
  //     image: bgImage,
  //     title: "Research Scientist",
  //   },
  //   {
  //     name: "Maj. Gen. Robert Chen",
  //     year: "1995",
  //     description: "Appointed as Defense Attaché to United Nations, Maj. Gen. Chen has played a crucial role in international peacekeeping missions and military diplomacy. Recipient of the Distinguished Service Medal.",
  //     image: bgImage,
  //     title: "Defense Attaché",
  //   },
  // ];


  // First, update the notifications data structure


  const handleShare = (item) => {
    const shareUrl = `${window.location.origin}/share/${item?.id}`;
    if (navigator.share) {
      navigator
        .share({ title: item?.title, text: item?.description, url: shareUrl })
        .catch(() => {});
    } else if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(shareUrl)
        .then(() => {
          alert('Link copied to clipboard');
        })
        .catch(() => {
          window.prompt('Copy this link', shareUrl);
        });
    } else {
      window.prompt('Copy this link', shareUrl);
    }
  };
  const membershipPaid = JSON.parse(localStorage?.getItem('membershipPaid'))

  const handleReadMore = (description) => {
    setDescription(description);
    setShowDescription(true);
  };

  // Lock body scroll when modal is open
  useEffect(() => {
    if (showDescription) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showDescription]);
  return (
    <div className="min-h-screen bg-gray-50">

      <div className="relative bg-gradient-to-r  from-[#800000] to-[#4b0000]  text-white pt-20 sm:pt-24 pb-10 sm:pb-16">
        <div className="absolute inset-0 overflow-hidden">
          <svg
            className="absolute w-full h-full"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <pattern
              id="hero-pattern"

              x="0"
              y="0"
              patternUnits=""
            >
              <path
                d="M10 0H0V10H10V0ZM9 5C9 7.20914 7.20914 9 5 9C2.79086 9 1 7.20914 1 5C1 2.79086 2.79086 1 5 1C7.20914 1 9 2.79086 9 5Z"
                fill="white"
                fillOpacity="0.1"
              />
            </pattern>
            <rect
              x="0"
              y="0"
              width="100%"
              height="100%"
              fill="url(#hero-pattern)"
            />
          </svg>
        </div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="flex flex-col md:flex-row items-center justify-between gap-5 sm:gap-7 md:gap-12">
            <div className="md:w-1/2 animate-[fadeIn_1s_ease-out]">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 sm:mb-8 font-crimson-text leading-tight">
            Welcome to Sainik School Ghorakhal Alumni Portal
              </h1>
              <p className="text-base sm:text-lg md:text-xl mb-8 sm:mb-10 opacity-90 leading-relaxed">
Reconnect with the spirit of Ghorakhal! This platform is designed to bring together the proud alumni of Sainik School Ghorakhal — a place where discipline meets camaraderie and lifelong friendships are forged.

Stay connected with your alma mater and fellow Ghorakhalites. Share your experiences, celebrate achievements, and support each other in personal and professional journeys. Whether you're reliving old memories, expanding your network, or mentoring the next generation, this portal is your bridge back to the school that shaped us all.

Join us in building a vibrant and strong alumni community. Together, let's honor the legacy of Sainik School Ghorakhal and inspire future leaders!
              </p>

                          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 p-4">
                            {!isAuthenticated && (
                              <>
                                <button
                                  onClick={() => navigate('/pages/authentication/sign-in')}
                                  className="px-8 py-4 bg-white text-blue-600 rounded-xl hover:bg-opacity-90 transition-all shadow-lg hover:shadow-2xl transform hover:-translate-y-1 font-medium"
                                >
                                  Login
                                </button>
                                <button
                                  onClick={() => navigate('/pages/authentication/sign-up')}
                                  className="px-8 py-4 border-2 border-white text-white rounded-xl hover:bg-white hover:text-blue-600 transition-all transform hover:-translate-y-1 font-medium"
                                >
                                  Register
                                </button>
                              </>
                            )}
                          </div>
            </div>
            <div className="md:w-1/2 animate-[slideIn_1s_ease-out]">
              <div className="relative">
                <div className="absolute -inset-4 bg-white/20 rounded-2xl blur-xl"></div>
                <img
                  src={bgImage}
                  alt="Alumni gathering at campus"
                  className="relative w-full h-auto rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-all duration-300"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {user && (
            <div className="container mx-auto px-4 py-8">
              <div className="bg-gradient-to-r from-[#D4AF37]/10 to-transparent rounded-xl p-6 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center text-white text-xl font-semibold">
                    {user.first_name?.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800">Welcome back, {user.first_name}!</h3>
                <p className="text-gray-600">Stay connected with your alma mater and fellow alumni<br/>
                {(!membershipPaid) ? `It seems your membership is not paid to access all features in Alumini Portal like Alumini search, gate pass etc ensure your membership is paid`:''}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

      <div id="events" className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <h2 className="text-4xl font-bold mb-16 text-left font-crimson-text">
           Events
        </h2>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {loading ? (
            // Loading skeleton
            [...Array(4)].map((_, index) => (
              <div key={index} className="animate-pulse">
                <div className="bg-gray-200 rounded-lg h-48 mb-4"></div>
                <div className="bg-gray-200 rounded h-4 w-3/4 mb-2"></div>
                <div className="bg-gray-200 rounded h-4 w-1/2"></div>
              </div>
            ))
          ) : events.length > 0 ? (
            events.map((event, index) => (
              <div
                key={event.id || index}
                className="group transform hover:-translate-y-2 transition-all duration-300"
              >
                <EventCard
                  title={event.ev_name}
                  venue={event.venue}
                  location={event.venue}
                  date={new Date(event.timing).toLocaleDateString()}
                  time={new Date(event.timing).toLocaleTimeString()}
                  category={event?.description}

                  imageUrl={event.attachments?.[0] ? `${base_URL}/get-image?objectKey=${event.attachments[0]}` : bgImage}
                  imageAlt={event.ev_name}
                  onRSVP={() => alert("RSVP clicked")}
                />
              </div>
            ))
          ) : (
            <div className="col-span-4 text-center py-12">
              <p className="text-gray-500 text-lg">No upcoming events at the moment.</p>
            </div>
          )}
        </div>
      </div>

      <div id="meetups" className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <div className="flex justify-between items-center mb-16">
          <h2 className="text-4xl font-bold text-left font-crimson-text">
            Recent Meetups
          </h2>
          <button
            onClick={() => setShowFeedsModal(true)}
            className="px-6 py-2 bg-gradient-to-r from-[#800000] to-[#5a0000] text-white rounded-lg
                     font-medium transition-all duration-300 flex items-center gap-2 hover:from-[#5a0000] hover:to-[#3d0000]"
          >
            <i className="fas fa-list"></i>
            View All Feeds
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {loading ? (
            // Loading skeleton
            [...Array(3)].map((_, index) => (
              <div key={index} className="animate-pulse">
                <div className="bg-gray-200 rounded-lg h-48 mb-4"></div>
                <div className="bg-gray-200 rounded h-4 w-3/4 mb-2"></div>
                <div className="bg-gray-200 rounded h-4 w-1/2"></div>
              </div>
            ))
          ) : feeds.length > 0 ? (
            feeds.slice(0, 2).map((feed, index) => (
              <div
                key={feed.id || index}
                className="group transform hover:-translate-y-2 transition-all duration-300"
              >
                <Post
                  id={feed.id}
                  title={feed.title}
                  description={feed.description}
                  imageUrl={feed.media_url?.[0] ? `${base_URL}/get-image?objectKey=${feed.media_url[0]}` : bgImage}
                  date={new Date(feed.date_conducted).toLocaleDateString()}
                  location={feed.place}
                  likes={0}
                  comments={0}
                  shares={0}
                  media_url={feed.media_url}
                  base_URL={base_URL}
                  badge={{
                    text: feed.feed_type?.charAt(0).toUpperCase() + feed.feed_type?.slice(1) || 'Meetup',
                    color: feed.feed_type === 'meetup' ? 'bg-[#D4AF37]/10 text-[#D4AF37]' :
                           feed.feed_type === 'information' ? 'bg-blue-50 text-blue-600' :
                           'bg-green-50 text-green-600'
                  }}
                />
              </div>
            ))
          ) : (
            <div className="col-span-3 text-center py-12">
              <p className="text-gray-500 text-lg">No recent meetups at the moment.</p>
            </div>
          )}
        </div>
      </div>

      {/* Feeds Modal */}
      <FeedsModal
        isOpen={showFeedsModal}
        onClose={() => setShowFeedsModal(false)}
        base_URL={base_URL}
      />



      {/* <div id="fundraising" className="container mx-auto px-4 py-24">
        <h2 className="text-4xl font-bold mb-16 text-left font-crimson-text">
          Support Our Causes
        </h2>

         <DonationComponent/>

      </div> */}

      <div id="news" className="bg-gray-100 py-16 sm:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-1 gap-16">
            <div className="space-y-8">
              <h2 className="text-4xl font-bold mb-12 font-crimson-text">
                Latest News
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">

              {news.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden"
                >
                  {item.media_url && (
                    <div className="relative h-48 sm:h-60 overflow-hidden" id={`media-container-${item.id}`}>
                      {item.media_url.map((media, mediaIndex) => {
                        const isVideo = media.match(/\.(mp4|webm|ogg|mov|avi|wmv|flv|mkv|m4v|MP4)$/i);
                        const mediaUrl = `${base_URL}/get-image?objectKey=${media}`;

                        return (
                          <div
                            key={mediaIndex}
                            className="absolute inset-0 transition-opacity duration-300"
                            style={{ display: mediaIndex === 0 ? 'block' : 'none' }}
                            data-index={mediaIndex}
                          >
                            {isVideo ? (
                              <video
                                src={mediaUrl}
                                className="w-full h-full object-cover"
                                controls
                                playsInline
                                muted
                                loop
                              >
                                <source src={mediaUrl} type="video/mp4" />
                              </video>
                            ) : (
                              <img
                                src={mediaUrl}
                                alt={`${item.title} - ${mediaIndex + 1}`}
                                className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
                              />
                            )}
                          </div>
                        );
                      })}

                      {/* Navigation Arrows and Dots */}
                      {item.media_url.length > 1 && (
                        <>
                          <button
                            onClick={() => {
                              const container = document.getElementById(`media-container-${item.id}`);
                              const currentSlide = container.querySelector('[style="display: block;"]');
                              const currentIndex = parseInt(currentSlide.dataset.index);
                              const newIndex = (currentIndex - 1 + item.media_url.length) % item.media_url.length;

                              container.querySelectorAll('[data-index]').forEach(el => {
                                el.style.display = 'none';
                              });
                              container.querySelector(`[data-index="${newIndex}"]`).style.display = 'block';
                            }}
                            className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors z-10"
                            aria-label="Previous media"
                          >
                            <i className="fas fa-chevron-left"></i>
                          </button>
                          <button
                            onClick={() => {
                              const container = document.getElementById(`media-container-${item.id}`);
                              const currentSlide = container.querySelector('[style="display: block;"]');
                              const currentIndex = parseInt(currentSlide.dataset.index);
                              const newIndex = (currentIndex + 1) % item.media_url.length;

                              container.querySelectorAll('[data-index]').forEach(el => {
                                el.style.display = 'none';
                              });
                              container.querySelector(`[data-index="${newIndex}"]`).style.display = 'block';
                            }}
                            className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors z-10"
                            aria-label="Next media"
                          >
                            <i className="fas fa-chevron-right"></i>
                          </button>
                          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                            {item.media_url.map((_, index) => (
                              <button
                                key={index}
                                onClick={() => {
                                  const container = document.getElementById(`media-container-${item.id}`);
                                  container.querySelectorAll('[data-index]').forEach(el => {
                                    el.style.display = 'none';
                                  });
                                  container.querySelector(`[data-index="${index}"]`).style.display = 'block';
                                }}
                                className="w-2 h-2 rounded-full bg-white/50 hover:bg-white/80 transition-colors"
                                aria-label={`Go to media ${index + 1}`}
                              />
                            ))}
                          </div>
                        </>
                      )}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent pointer-events-none"></div>
                    </div>
                  )}
                  <div className="p-6 sm:p-8">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
                      <h3 className="text-2xl font-bold text-gray-900 mb-2 sm:mb-0">
                        {item.title}
                      </h3>
                      <div className="flex items-center gap-2 text-sm text-gray-500">
                        <i className="fas fa-calendar-alt"></i>
                        <span>News of {new Date(item.date_conducted)?.toLocaleDateString()}</span>
                      </div>
                    </div>
                    <p className="text-gray-600 leading-relaxed mb-6">
                      {item.description.length > 100 ? item.description.slice(0, 100) + '...' : item.description}
                      {item.description.length > 100 && <button className="text-[#D4AF37] hover:text-[#C5A028] transition-colors duration-200 flex items-center gap-2" aria-label="Read more" onClick={()=>{handleReadMore(item.description)}}>Read more</button>}
                    </p>
                    <div className="flex justify-between items-center pt-4 border-t border-gray-100">

                      <button className="text-[#D4AF37] hover:text-[#C5A028] transition-colors duration-200 flex items-center gap-2" aria-label="Share news"    onClick={()=>{handleShare(item)}}>

                        <i className="fas fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
              </div>
            </div>
            <div id="achievements" className="space-y-8">
              <div className="flex justify-between items-center">
                <h2 className="text-4xl font-bold mb-5 font-crimson-text">
                  Alumni Achievements
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
              {achievements.map((item, index) => (
                <div
                  key={index}
                  className="bg-white p-4 sm:p-6 md:p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 flex flex-col sm:flex-row gap-4 sm:gap-6"
                >
                  <div className="flex-shrink-0 flex justify-center">
                    <img
                      src={item.media_url?.[0]? `${base_URL}/get-image?objectKey=${item.media_url[0]}` : bgImage}
                      alt={item.title}
                      className="w-24 h-24 sm:w-32 sm:h-32 rounded-full object-cover border-4 border-[#D4AF37]/20"
                    />
                  </div>
                  <div className="flex-grow">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2 sm:gap-0">
                      <div>
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900">{item.name}</h3>
                        <p className="text-[#D4AF37] font-medium">
                          {item.title}
                        </p>
                      </div>
                      {/* <span className="px-4 py-2 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-sm font-medium whitespace-nowrap">
                        Class of {item.year}
                      </span> */}
                    </div>
                    <p className="text-gray-600 leading-relaxed mb-4 text-sm sm:text-base">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
              </div>
            </div>
          </div>
        </div>
        {showDescription && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto p-4"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setShowDescription(false);
              }
            }}
          >
            <div className="bg-white p-8 rounded-xl shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto relative">
              <button
                className="text-[#D4AF37] hover:text-[#C5A028] transition-colors duration-200 flex items-center gap-2 absolute top-4 right-4 z-10 bg-white rounded-full p-2 shadow-md hover:shadow-lg"
                aria-label="Close"
                onClick={() => { setShowDescription(false); }}
              >
                <i className="fas fa-times"></i>
              </button>
              <div className="text-base leading-relaxed font-crimson-text pr-8">
                {description}
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx global>{`
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes slideIn {
    from { transform: translateX(20px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
`}</style>
    </div>
  );



}



export default MainComponent;